export default "__VITE_ASSET__YpfKbZxz__"